import { Dialog, ButtonGroup } from "@material-ui/core";
import { useState } from "react";
import { DialogPaper, DialogButton } from "../../../components/Dialogs";
import { useDispatch } from "react-redux";
import { deleteInstalledApp } from "../InstalledAppSlice";
import { useTypedSelector } from "../../../app/store";
import axios from "axios";

/**
 * APIを削除するダイアログ
 */
export const useInstalledAppDeleteDialogs = () => {
  const [open, setOpen] = useState<boolean>(false);
  const openDialog = () => setOpen(true);
  const { accessToken, selectInstalledApp, isLoadings } = useTypedSelector(
    (x) => ({
      ...x.login,
      ...x.installedApplication,
    })
  );

  const source = axios.CancelToken.source();
  const dispatch = useDispatch();
  const handleDeleteInstalledApp = () => {
    dispatch(
      deleteInstalledApp({
        accessToken: accessToken!,
        applicationId: selectInstalledApp!.applicationId!,
        cancelToken: source.token,
      })
    );
  };
  const handleCancel = () => {
    setOpen(false);
    // source.cancel();
  };

  const InstalledAppDeleteDialog = (
    <Dialog open={open}>
      <DialogPaper
        title="登録アプリの連携解除"
        message={`「${selectInstalledApp?.name}」との連携を解除してもよろしいですか？`}
        buttonGroup={
          <ButtonGroup>
            {isLoadings.deleteInstalledApp ? (
              <>
                <DialogButton color="secondary" isProcessing />
                <DialogButton
                  color="default"
                  label="キャンセル"
                  disabled
                  onClick={handleCancel}
                />
              </>
            ) : (
              <>
                <DialogButton
                  color="secondary"
                  label="連携解除"
                  onClick={handleDeleteInstalledApp}
                />
                <DialogButton
                  color="default"
                  label="キャンセル"
                  onClick={handleCancel}
                />
              </>
            )}
          </ButtonGroup>
        }
      />
    </Dialog>
  );

  return { openDialog, InstalledAppDeleteDialog };
};
